import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

import CategoriesList from "cxfcomponents/Lists/CategoriesList";
import { ThemedHistoryIcon } from "assets/CXFIcons/Portal/Dashboard";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { getLocalDateTimeString } from "helpers/common";
import { useOwnedSharedFlows } from "hooks/useOwnedSharedFlows";

const BottomAction = () => {
  return (
    <SoftBox>
      <SoftButton
        sx={{ float: "right" }}
        component={Link}
        to="/workspace/flows"
        variant="text"
        color="primary"
      >
        View All <ArrowForwardIcon sx={{ marginLeft: "12px" }} />
      </SoftButton>
    </SoftBox>
  );
};

const RecentActivity = () => {
  const { ownedSharedFlows, isLoading } = useOwnedSharedFlows();
  const [categories, setCategories] = useState([]);
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    const categories = ownedSharedFlows?.map((flow) => ({
      id: flow.id,
      color: "dark",
      icon: "",
      name: (
        <Link
          to={`/designer/${flow.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {flow.name}
        </Link>
      ),
      //description: getLocalDateTimeString(flow.updated_date_time || flow.created_date_time) || "",
      description: (
        <Link
          to={`/designer/${flow.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {getLocalDateTimeString(flow.updated_date_time || flow.created_date_time) || ""}
        </Link>
      )
      // route: `/designer/${flow.id}`,
    }));
    setCategories(categories);
  }, [ownedSharedFlows]);

  return (
    <CategoriesList
      title={t("labels.recently_worked_on")}
      categories={categories}
      headerIcon={<ThemedHistoryIcon sx={{ position: "relative", top: "9px" }} />}
      isLoading={isLoading}
      noDataMessage={t("messages.no_recent_activities")}
      bottomAction={<BottomAction />}
      isFlows={true}
    />
  );
};

export default RecentActivity;
